document.addEventListener('DOMContentLoaded', () => {
    
    // parallax
    function getParallaxOffset(element, speed = 0.3) {
        if (!element) return 0;

        const rect = element.getBoundingClientRect();
        const elementCenter = rect.top + (rect.height / 2);
        const viewportCenter = window.innerHeight / 2;
        const distance = viewportCenter - elementCenter;

        return distance * speed;
    }
    const parallaxElements = document.querySelectorAll('.oa-parallax');
    window.addEventListener('scroll', () => {
        parallaxElements.forEach(el => {
            const offset = getParallaxOffset(el, el.dataset.parallaxSpeed ?? 0.3);
            // if el also has class is-centered
            if (el.classList.contains('is-centered'))
                el.style.transform = `translate(-50%, -50%) translateY(${offset}px)`;
            else{
                el.style.transform = `translateY(${offset}px)`;
            }
        });
    });

    // animate scroll watcher
    const animateObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('active');
            } else {
                entry.target.classList.remove('active');
            }
        });
    }, { rootMargin: '0px 0px -25% 0px' });
    document.querySelectorAll('.animate').forEach(el => {
        animateObserver.observe(el);
    });

    // for fixed cta
    const fixedTrigger = document.querySelector('.trigger-fixed');
    const stickyObserver = new IntersectionObserver(([entry]) => {
        const isPastTop = entry.boundingClientRect.top < 0 && !entry.isIntersecting;
        document.querySelector('.fixed-cta').classList.toggle('active', isPastTop);
    }, {
        threshold: 0,
        rootMargin: '0px'
    });
    if (fixedTrigger) {
        stickyObserver.observe(fixedTrigger);
    }

    // for fixed cta — contact form proximity
    const contactForm = document.querySelector('#oa-contact-form');
    const fixedCta = document.querySelector('.fixed-cta');
    if (contactForm && fixedCta) {
        const sentinel = document.createElement('div');
        contactForm.prepend(sentinel);
        const contactFormObserver = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                fixedCta.classList.remove('active');
            } else if (entry.boundingClientRect.top > 60) {
                fixedCta.classList.add('active');
            }
        }, {
            rootMargin: '-60px 0px 0px 0px',
            threshold: 0
        });
        contactFormObserver.observe(sentinel);
    }

    // for center focus animations
    const centerFocusObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          entry.target.classList.toggle('is-centered', entry.isIntersecting);
        });
    }, {
        rootMargin: '-50% 0px -50% 0px',
        threshold: 0
    });
        document.querySelectorAll('.center-focus').forEach(el => {
        centerFocusObserver.observe(el);
    });
      
});
